import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "calc(100vh - 80px)",
    "@media screen and (max-width:800px)": {
      minHeight: "calc(100vh - 64px)",
    },
  },
});

function PageLoading() {
  const { classes } = useStyles();
  return <div className={classes.root}>loading...</div>;
}

export default PageLoading;
